module.exports = __webpack_public_path__ + "static/media/trophy-alt.3a26bf2c.svg";